const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/main.ts';
import '@babel/polyfill';

import { createElement } from 'react';

import { RootFrame } from './layout/RootFrame';

import './main.less';
import { createRoot } from 'react-dom/client';

declare const require: any;

function startApp() {
    const domRootElement = document.getElementById('react-mount-pt');
    const root = createRoot(domRootElement!);
    root.render(createElement(RootFrame, null));
}

// check if polyfill is required
if (!(window as any)['Intl' as any]) {
    require.ensure(
        [
            'intl',
            'intl/locale-data/jsonp/en.js',
            'intl/locale-data/jsonp/de.js',
            'intl/locale-data/jsonp/fr.js',
            'intl/locale-data/jsonp/it.js',
        ],
        (theRequire: any) => {
            theRequire('intl');
            theRequire('intl/locale-data/jsonp/en.js');
            theRequire('intl/locale-data/jsonp/de.js');
            theRequire('intl/locale-data/jsonp/fr.js');
            theRequire('intl/locale-data/jsonp/it.js');
            startApp();
        }
    );
} else {
    startApp();
}
